/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExhibitionPageTransitionOptionsMorphView,
    ExhibitionPageTransitionOptionsMorphViewFromJSON,
    ExhibitionPageTransitionOptionsMorphViewFromJSONTyped,
    ExhibitionPageTransitionOptionsMorphViewToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExhibitionPageTransitionOptionsMorph
 */
export interface ExhibitionPageTransitionOptionsMorph {
    /**
     * 
     * @type {Array<ExhibitionPageTransitionOptionsMorphView>}
     * @memberof ExhibitionPageTransitionOptionsMorph
     */
    views: Array<ExhibitionPageTransitionOptionsMorphView>;
}

export function ExhibitionPageTransitionOptionsMorphFromJSON(json: any): ExhibitionPageTransitionOptionsMorph {
    return ExhibitionPageTransitionOptionsMorphFromJSONTyped(json, false);
}

export function ExhibitionPageTransitionOptionsMorphFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExhibitionPageTransitionOptionsMorph {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'views': ((json['views'] as Array<any>).map(ExhibitionPageTransitionOptionsMorphViewFromJSON)),
    };
}

export function ExhibitionPageTransitionOptionsMorphToJSON(value?: ExhibitionPageTransitionOptionsMorph | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'views': ((value.views as Array<any>).map(ExhibitionPageTransitionOptionsMorphViewToJSON)),
    };
}


